// extracted by mini-css-extract-plugin
export default {"item":"styles_item__Rq0Fm","pair":"styles_pair__iH5PB","price":"styles_price__w6lVs"};